import React from "react";
import OrderDTO from "@/dto/order/OrderDTO";
import OrderTag from "@/enum/OrderTag";
import ShopDTO from "@/dto/shop/ShopDTO";
import OrderTagWrap from "../OrderTagWrap";
import { Tooltip } from "antd";
import OrderTagNameMap from "@/map/OrderTagNameMap";

/**
 * 快手平台标签组件
 * 包含所有快手相关的标签逻辑
 */
export default function useKwaiTagIcons(order: OrderDTO, orderTagSet: Set<OrderTag>, shop: ShopDTO) {
    const icons = [];

    if (orderTagSet.has(OrderTag.KWAI_PRIORITY_DELIVERY)) {
        icons.push(
            <OrderTagWrap
                className="order-icon icon-important"
                key={OrderTag.KWAI_PRIORITY_DELIVERY}
                orderTag={OrderTag.KWAI_PRIORITY_DELIVERY}
            >
                优先发货
            </OrderTagWrap>,
        );
    }

    if (orderTagSet.has(OrderTag.KWAI_SHIP_BY_SF)) {
        icons.push(
            <Tooltip
                title="“顺丰包邮”订单必须使用顺丰快递打印发货，否则将被快手平台处罚"
                key={OrderTag.KWAI_SHIP_BY_SF}
            >
                <OrderTagWrap
                    className="order-icon icon-important"
                    style={{ whiteSpace: "nowrap" }}
                    orderTag={OrderTag.KWAI_SHIP_BY_SF}
                />
            </Tooltip>,
        );
    }

    if (orderTagSet.has(OrderTag.KWAI_SHIP_BY_SF_RECOMMEND)) {
        icons.push(
            <Tooltip title="平台推荐使用顺丰发货" key={OrderTag.KWAI_SHIP_BY_SF_RECOMMEND}>
                <OrderTagWrap className="order-icon icon-unimportant" orderTag={OrderTag.KWAI_SHIP_BY_SF_RECOMMEND} />
            </Tooltip>,
        );
    }

    [
        OrderTag.KWAI_CONSOLIDATION_XINJIANG,
        OrderTag.KWAI_CONSOLIDATION_NEIMENGGU,
        OrderTag.KWAI_CONSOLIDATION_QINGHAI,
        OrderTag.KWAI_CONSOLIDATION_GANSU,
        OrderTag.KWAI_CONSOLIDATION_NINGXIA,
        OrderTag.KWAI_CONSOLIDATION_XIZANG,
    ].forEach((orderTag) => {
        if (orderTagSet.has(orderTag)) {
            icons.push(
                <Tooltip
                    key={orderTag}
                    title={
                        <span>
                            该订单为{OrderTagNameMap[orderTag]}
                            订单，将先发往中转仓，再由快手官方中转仓发送到消费者地址。收货信息为中转仓信息，若需要查看消费者收货地址，请前往快手小店商家后台查看
                        </span>
                    }
                >
                    <OrderTagWrap
                        className="order-icon icon-important"
                        style={{ whiteSpace: "nowrap" }}
                        orderTag={orderTag}
                    />
                </Tooltip>,
            );
        }
    });

    if (orderTagSet.has(OrderTag.KWAI_TOMORROW_ARRIVAL)) {
        icons.push(
            <OrderTagWrap
                className="order-icon icon-important"
                orderTag={OrderTag.KWAI_TOMORROW_ARRIVAL}
                key={OrderTag.KWAI_TOMORROW_ARRIVAL}
            />,
        );
    }

    if (orderTagSet.has(OrderTag.KWAI_NEXT_DAY_ARRIVAL)) {
        icons.push(
            <OrderTagWrap
                className="order-icon icon-important"
                orderTag={OrderTag.KWAI_NEXT_DAY_ARRIVAL}
                key={OrderTag.KWAI_NEXT_DAY_ARRIVAL}
            />,
        );
    }

    if (orderTagSet.has(OrderTag.KWAI_PICK_UP_IN24H)) {
        icons.push(
            <Tooltip title="建议对该订单优先完成发货及揽收，有助升对应商品履约表现" key={OrderTag.KWAI_PICK_UP_IN24H}>
                <OrderTagWrap className="order-icon icon-unimportant" orderTag={OrderTag.KWAI_PICK_UP_IN24H} />
            </Tooltip>,
        );
    }

    return icons;
}
